import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, of } from 'rxjs'
import { catchError, distinctUntilChanged, filter, map, skipWhile, tap } from 'rxjs/operators'
import { FALLBACK_ROLES } from 'src/environments/go-api-fallbacks'

import { ApiService } from '@shared/services/api.service'
import { Role } from '@shared/models/role.model'
import { AuthService } from '@app/modules/auth/auth.service'
import { allowedRolesStarterPlan } from '@core/constants/roles'
import { User } from '@shared/models/user.model'
@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private clientTeamRolesSubject = new BehaviorSubject<Role[]>(null)
  clientTeamRoles$ = this.clientTeamRolesSubject.asObservable().pipe(
    skipWhile((data) => !data),
    distinctUntilChanged(),
  )

  private adminTeamRolesSubject = new BehaviorSubject<Role[]>(null)
  adminTeamRoles$ = this.adminTeamRolesSubject.asObservable().pipe(
    skipWhile((data) => !data),
    distinctUntilChanged(),
  )

  private resellerTeamRolesSubject = new BehaviorSubject<Role[]>(null)
  resellerTeamRoles$ = this.resellerTeamRolesSubject.asObservable().pipe(
    skipWhile((data) => !data),
    distinctUntilChanged(),
  )

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
  ) {}

  populate() {
    return this.getRoles().pipe(tap((roles) => this.setRoles(roles)))
  }

  getRoles() {
    return this.apiService.get('/roles').pipe(
      map((resp) => resp['data']),
      catchError(() => of(FALLBACK_ROLES)),
    ) as any as Observable<Role[]>
  }

  setRoles(data): void {
    let clientTeamRoles = data.filter((r) => r.team === 'client')
    const adminTeamRoles = data.filter((r) => r.team === 'admin')
    const resellerTeamRoles = data.filter((r) => r.team === 'reseller')

    this.authService.currentUser$.pipe(filter(Boolean)).subscribe((user: User) => {
      const userPlan = user.plan?.name

      if (userPlan === 'starter') {
        clientTeamRoles = clientTeamRoles.filter((r) => allowedRolesStarterPlan.includes(r.name))
      }
      this.clientTeamRolesSubject.next(clientTeamRoles)
    })
    this.adminTeamRolesSubject.next(adminTeamRoles)
    this.resellerTeamRolesSubject.next(resellerTeamRoles)
  }
}
